@if (!configError() && config() && isEnabled()) {
  <div
    class="widget-host"
    [class.widget-host--right]="position() === 'right'"
    [class.widget-host--left]="position() === 'left'"
    [class.widget-host--mobile]="isMobile()"
  >
    @if (isOpen() || embedded) {
      <webchat-multi-location-box
        [view]="view()"
        [selectedLocation]="selectedLocation()"
        [color]="config()?.color ?? ''"
        [textColor]="config()?.textColor ?? ''"
        [accentColor]="config()?.accentColor ?? ''"
        [accentTextColor]="config()?.accentTextColor ?? ''"
        [welcomeMessage]="config()?.welcomeMessage ?? ''"
        [assistantAvatarUrl]="config()?.assistantAvatarUrl ?? ''"
        [position]="position()"
        [showFooterContent]="!!config()?.showFooterContent"
        [poweredByName]="config()?.poweredByName ?? ''"
        [poweredByUrl]="config()?.poweredByUrl ?? ''"
        [locations]="locations()"
        [isLoading]="isLoading()"
        [error]="error()"
        [hasMore]="hasMore()"
        [hasPrev]="hasPrev()"
        [currentPage]="currentPage()"
        [embedded]="embedded"
        [mobile]="isMobile()"
        [currentParticipantId]="currentParticipantId()"
        [messageGroups]="messageGroups()"
        [messages]="messages() ?? []"
        [processing]="isCreatingConversation()"
        [isReplying]="isReplying()"
        (searchChanged)="onSearch($event)"
        (selectLocation)="selectLocation($event)"
        (back)="goBack()"
        (nextPage)="nextPage()"
        (prevPage)="prevPage()"
        (closeClicked)="closeWidget()"
        (retry)="retrySearch()"
        (sentMessage)="sendMessage($event)"
      ></webchat-multi-location-box>
    }
    @if (!embedded && !(isMobile() && isOpen())) {
      <webchat-button
        (clicked)="isOpen() ? closeWidget() : openWidget()"
        [hideStatus]="isOpen()"
        [position]="position()"
        [backgroundColor]="config()?.color"
        [iconColor]="config()?.textColor === 'light' ? 'light' : 'dark'"
      ></webchat-button>
    }
  </div>
}
